import React, { useEffect, useState } from 'react'
import { Radio } from '../Radio'

import { Label } from 'Views/survey/forms/Builder/components/Label/Label'
import { Container, ContainerRadio } from './InputRadio.styles'

export interface InputRadioProps {
	text: string
	id: string
	options: any
	questionAnswerId: any
	onChange: any
	isVisible?: boolean
}

export const InputRadio = ({
	text,
	id,
	options,
	questionAnswerId,
	onChange,
	isVisible,
}: InputRadioProps): JSX.Element => {
	const [value, setValue] = useState<any>(null)

	const formatterToValue = {
		[options.find((option: any) => option.description === 'Si').id]: true,
		[options.find((option: any) => option.description === 'No').id]: false,
	}

	const formatterValue = (value: boolean) => {
		if (value === true) {
			return options.find((option: any) => option.description === 'Si').id
		}
		if (value === false) {
			return options.find((option: any) => option.description === 'No').id
		}
	}

	useEffect(() => {
		if (questionAnswerId) {
			const questionAnswerIdMarked = formatterToValue[questionAnswerId]

			setValue(questionAnswerIdMarked)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options, questionAnswerId])

	if (!isVisible) {
		return <input id={id} value="empty" style={{ display: 'none' }} />
	}

	return (
		<Container>
			<Label>{text}</Label>
			<input
				id={id}
				style={{ display: 'none' }}
				value={formatterValue(value)}
			/>
			<ContainerRadio>
				<Radio
					id={`index-si-${id}`}
					label="Sí"
					name={`index-si-${id}`}
					variant="primary"
					size="medium"
					checked={value === true}
					value=""
					onChange={() => {
						setValue(true)
						onChange({
							id,
							questionAnswerId: formatterValue(true),
						})
					}}
				/>
				<Radio
					id={`index-no-${id}`}
					label="No"
					name={`index-si-${id}`}
					variant="primary"
					size="medium"
					checked={value === false}
					value=""
					onChange={() => {
						setValue(false)
						onChange({
							id,
							questionAnswerId: formatterValue(false),
						})
					}}
				/>
			</ContainerRadio>
		</Container>
	)
}
